import React from "react";
import ProductPriceRow from "components/ProductForm/ProductPriceRow";
import { groupProductPrices } from "utils/price";
import classnames from "classnames";

const ProductPricesIndex = ({ prices }) => {
  const priceGroups = groupProductPrices(prices);
  const nodes = priceGroups.map(({ label, uid, sections }, nodeIx) => {
    const hasBreakdownSections = sections.length > 1;
    const ctxSections = hasBreakdownSections ? sections.slice(1) : sections;
    const groupNodes = ctxSections.reduce((memo, section, sectionIx) => {
      const pricesCount = section.prices.length;

      const subNodes = section.prices.map((price, priceIx) => {
        const isFirst = !priceIx;
        const isLast = priceIx === pricesCount - 1;

        return (
          <ProductPriceRow
            key={price.id}
            isFirst={isFirst}
            isLast={isLast}
            priceIx={priceIx}
            price={price}
          />
        );
      });

      if (hasBreakdownSections) {
        subNodes.unshift(
          <label
            key={`label-${sectionIx}`}
            className={classnames("f7 pb2 dib fw5", {
              pt3: sectionIx
            })}
          >
            {section.label}
          </label>
        );
      }
      memo = memo.concat(subNodes);
      return memo;
    }, []);

    return (
      <li className={nodeIx ? "pt3" : ""} key={uid}>
        <label className="f6 pb3 dib fw5">{label}</label>
        <ul className="ma0 pa0 list">{groupNodes}</ul>
      </li>
    );
  });

  return <ul className="w-100 ma0 pa0 list">{nodes}</ul>;
};

export default ProductPricesIndex;
